import { useMutation, useQueryClient } from 'react-query';
import { BASE_API_URL } from '@env';
import { Business } from '~types/api/business';
import { useUserStore } from '~providers/userStore/zustand';

const useUpdateBusiness = () => {
  const queryClient = useQueryClient();
  const mutation = useMutation(
    async (userData: Partial<Omit<Business, 'created_at' | 'updated_at' | 'target_audiences'>>) => {
      const token = useUserStore.getState().token;
      const response = await fetch(`${BASE_API_URL}businesses/${userData.uid}`, {
        method: 'PATCH',
        headers: {
          'Content-Type': 'application/json',
          Authorization: token,
        },
        body: JSON.stringify({ ...userData, uid: useUserStore.getState().user?.uid }),
      });
      if (!response.ok) {
        throw new Error('Failed to update business user');
      }

      return response.json();
    },
    { onSuccess: () => queryClient.refetchQueries(['businessAccount']) },
  );

  return mutation;
};

export default useUpdateBusiness;
